import { VerificationRepository } from '../repositories/verification.repository'
import { VerificationGetSMSResponseT, VerificationGetTypesResponseT } from '../types/verification.types'

const verificationRepository = new VerificationRepository()

export class VerificationService {
    async sendSMS(payload: FormData): Promise<VerificationGetSMSResponseT> {
        const response = await verificationRepository.sendSMS(payload)
        return response.data
    }

    async sendSMSRepeat(payload: FormData): Promise<VerificationGetSMSResponseT> {
        const response = await verificationRepository.sendSMSRepeat(payload)
        return response.data
    }

    async confirm(payload: FormData): Promise<void> {
        const response = await verificationRepository.confirm(payload)
        return response.data
    }

    async getTypes(): Promise<VerificationGetTypesResponseT> {
        const response = await verificationRepository.getTypes()
        return response.data
    }
}
